export default __webpack_public_path__ + "static/media/home-background.25f4492b.png";